/* eslint-disable react-hooks/exhaustive-deps */
import { companyGetCompanyDetails } from "common/_redux/company/actions";
import { companyDetailsSelector } from "common/_redux/company/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import { goToTop } from "common/helpers/common-utils";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import BilancioImpresa from "./bilancio-impresa";
import DatiAziendali from "./dati-aziendali";
import DettaglioSocieta from "./dettagli-societa";
import IndirizziEContatti from "./indirizzi-contatti";
import PresentaAzienda from "./presenta-azienda";

const title = "2. La tua azienda";
const subtitle = "Necessitiamo di alcune informazioni sulla azienda che rappresenti.";

const SecondStepPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const companyDetails = useAppSelector(companyDetailsSelector);

	const activeAccordionIndex =
		(steps
			?.find((s) => s.route == AppRouterService.get(PathEnum.step2))
			?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0) + 1;

	const goBack = () => {
		navigate(-1);
	};

	const handleCompleteStep = (route: string) => {
		navigate(route);
	};

	const getCompanyDetails = () => {
		if (!companyDetails)
			dispatch(companyGetCompanyDetails())
				.unwrap()
				.then((res) => {
					if (!res) goBack();
				});
	};

	useEffect(() => {
		getCompanyDetails();

		if (location.pathname == AppRouterService.get(PathEnum.step2)) {
			navigate(AppRouterService.get(PathEnum.presentaAzienda), { replace: true });
		}
	}, []);

	useEffect(() => {
		setTimeout(() => {
			const id = activeAccordionIndex > 1 ? `accordion-${activeAccordionIndex}` : null;
			goToTop(id);
		}, 300);
	}, [location]);

	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Header />
					<Topbar />
					<div className="container-fluid body-section-no-header px-0">
						<section>
							<Row>
								<Col sm={12} lg={8}>
									<div>
										<h2 className="mb-3 ms-3">{title}</h2>
										<span className="gray">{subtitle}</span>
									</div>

									{/* Presentaci la tua azienda */}
									<BftAccordion
										title="Presentaci la tua azienda"
										index={1}
										total={5}
										isActive={location.pathname === AppRouterService.get(PathEnum.presentaAzienda)}
										isCompleted={activeAccordionIndex > 1}
									>
										<PresentaAzienda
											onComplete={() =>
												handleCompleteStep(AppRouterService.get(PathEnum.datiAziendali))
											}
										/>
									</BftAccordion>

									{/* Dati aziendali */}
									<BftAccordion
										title="Dati aziendali"
										index={2}
										total={5}
										isActive={location.pathname === AppRouterService.get(PathEnum.datiAziendali)}
										isCompleted={activeAccordionIndex > 2}
										disabled={activeAccordionIndex < 2 || !companyDetails?.idCliente}
									>
										<DatiAziendali
											onComplete={() =>
												handleCompleteStep(AppRouterService.get(PathEnum.indirizziContatti))
											}
										/>
									</BftAccordion>

									{/* Indirizzi e contatti */}
									<BftAccordion
										title="Indirizzi e contatti"
										index={3}
										total={5}
										isActive={
											location.pathname === AppRouterService.get(PathEnum.indirizziContatti)
										}
										isCompleted={activeAccordionIndex > 3}
										disabled={activeAccordionIndex < 3 || !companyDetails?.idCliente}
									>
										<IndirizziEContatti
											onComplete={() =>
												handleCompleteStep(AppRouterService.get(PathEnum.bilancioImpresa))
											}
										/>
									</BftAccordion>

									{/* Bilancio impresa */}
									<BftAccordion
										title="Bilancio impresa"
										index={4}
										total={5}
										isActive={location.pathname === AppRouterService.get(PathEnum.bilancioImpresa)}
										isCompleted={activeAccordionIndex > 4}
										disabled={activeAccordionIndex < 4 || !companyDetails?.idCliente}
									>
										<BilancioImpresa
											onComplete={() =>
												handleCompleteStep(AppRouterService.get(PathEnum.dettagliSocieta))
											}
										/>
									</BftAccordion>

									{/* Dettagli della società */}
									<BftAccordion
										title="Dettagli della società"
										index={5}
										total={5}
										isActive={location.pathname === AppRouterService.get(PathEnum.dettagliSocieta)}
										isCompleted={activeAccordionIndex > 5}
										disabled={activeAccordionIndex < 5 || !companyDetails?.idCliente}
									>
										<DettaglioSocieta
											onComplete={() =>
												handleCompleteStep(AppRouterService.get(PathEnum.step2Complete))
											}
										/>
									</BftAccordion>

									<Row className="justify-content-between mx-3">
										<Col xs={1} className="p-0">
											<BftButton className="btn-buffetti-secondary ms-0 px-3" onClick={goBack}>
												<i className="fas fa-arrow-left"></i>
											</BftButton>
										</Col>
										<Col xs={10} md={11} className="pe-0">
											<BftButton
												className="btn-buffetti col-12"
												isDisabled={activeAccordionIndex <= 5}
												onClick={() => handleCompleteStep(AppRouterService.get(PathEnum.step3))}
											>
												Vai allo step successivo
											</BftButton>
										</Col>
									</Row>
								</Col>

								<Col sm={12} md={4} className="side-card">
									<DettaglioPianoCard />
								</Col>
							</Row>
						</section>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

export default SecondStepPage;
